const CDN_LINK_SELECTOR = 'a[href*="//tcdn."]'
// keyup обязателен: линкер gtag слушает именно keyup, а не keydown (навигация Enter)
const GUARD_EVENTS = ['mousedown', 'pointerdown', 'click', 'keydown', 'keyup']

/**
 * gtag-линкер (cross-domain tracking GA4) перезаписывает href ссылок на CDN-домены
 * при клике, дописывая ?_gl=... Метки на tcdn никем не читаются, поэтому событие
 * на CDN-ссылке не должно доходить до слушателей линкера на document.
 * Слушатели вешаем в capture-фазе до TagManager.initialize, stopImmediatePropagation
 * обязателен: stopPropagation не глушит других слушателей на том же узле document.
 */
export function installCdnLinkGuard() {
  if (typeof document === 'undefined') return () => {}

  const guard = (e) => {
    if (e.target?.closest?.(CDN_LINK_SELECTOR)) {
      e.stopPropagation()
      e.stopImmediatePropagation()
    }
  }

  GUARD_EVENTS.forEach((type) => document.addEventListener(type, guard, true))

  return () => GUARD_EVENTS.forEach((type) => document.removeEventListener(type, guard, true))
}
